import { http } from '../rest';

export function fetchHoldingsReport(http, demo) {
  return {
    async execute(clientId, timeSpan) {
      if (demo) {
        const file = await import('./fetchClientHoldingsReport.data');
        return file.default();
      }
      const response = await http.get(`/clients/${clientId}/download/holdings${timeSpan}`);
      return response.data;
    },
  };
}

export default fetchHoldingsReport(http, process.env.DEMO);
